module.exports = __webpack_public_path__ + "img/notSigned.a3a3d7bc.png";